/**
 * Launch gate for the anonymous /try editors ("taste version").
 *
 * A build-time env var, deliberately NOT a Statsig flag: Statsig only
 * initializes after opt-in analytics consent, so a flag-gated launch would
 * stay closed for anonymous visitors who decline (or ignore) the consent
 * banner. Default off — flipping it on is a deploy.
 */
export const TRY_EDITORS_ENABLED = import.meta.env.VITE_TRY_EDITORS_ENABLED === 'true';

export type TryGateResult =
    | { kind: 'allow' }
    | { kind: 'redirect-signed-in' }
    | { kind: 'redirect-gated' };

/** Pure decision for the /try routes' beforeLoad. Signed-in users never see
 *  the try editors (they have the real thing — before or after launch);
 *  signed-out visitors get in only once the launch gate is open. */
export function tryGateResult(isSignedIn: boolean, enabled: boolean): TryGateResult {
    if (isSignedIn) return { kind: 'redirect-signed-in' };
    if (!enabled) return { kind: 'redirect-gated' };
    return { kind: 'allow' };
}
